import { Button, Container, Title, Text, Stack, Box, Group } from "@mantine/core";
import { IconPlane, IconLogin } from "@tabler/icons-react";
import classes from "./StartScreen.module.css";

export function StartScreen() {
  return (
    <div className={classes.wrapper}>
      <Container size="lg" className={classes.container}>
        <Stack align="center" gap="lg" className={classes.content}>
          {/* Logo placeholder */}
          <Box className={classes.logoPlaceholder}>
            <img src="https://spilve.org/pic/logo.png" />
          </Box>

          {/* Hero text */}
          <Stack align="center" gap="md" maw={700}>
            <Title className={classes.title} ta="center">
              Spilve Airport PPR System
            </Title>
            <Text size="lg" c="dimmed" ta="center" className={classes.description}>
              Submit your Prior Permission Request quickly and easily.
              Register your flight and get approval for landing at Spilve Airport.
            </Text>
          </Stack>

          {/* CTA Buttons */}
          <Group gap="md" className={classes.buttons}>
            <Button
              size="lg"
              radius="xl"
              leftSection={<IconPlane size={20} />}
              onClick={() => window.location.href = "/register-single"}
              className={classes.primaryButton}
            >
              Register Flight
            </Button>
            <Button
              size="lg"
              radius="xl"
              variant="default"
              leftSection={<IconLogin size={20} />}
              onClick={() => window.location.href = "/login"}
            >
              Login
            </Button>
          </Group>

          {/* Additional info */}
          <Text size="sm" c="dimmed" ta="center" mt="md">
            Already have an account? Login to manage your flights and view history.
          </Text>

          {/* LIAA Project Poster */}
          <Box mt="xl" style={{ maxWidth: 700, width: '100%' }}>
            <img
              src="/LIAA_plakats.png"
              alt="LIAA projekta informācija"
              style={{ width: '100%', borderRadius: 8 }}
            />
          </Box>
        </Stack>
      </Container>
    </div>
  );
}